const projects = [
  // --- Phase 1: The Basics ---
  {
    id: 1,
    title: "Accordion",
    description: "A clean, collapsible interface for organizing content. Perfect for FAQs and keeping your UI clutter-free.",
    path: "project/accordion",
  },
  {
    id: 2,
    title: "Random Color Generator",
    description: "Instantly generate Hex and RGB color codes. A fun tool to discover fresh color palettes for your designs.",
    path: "project/random-color-generator",
  },
  {
    id: 3,
    title: "Custom Tabs",
    description: "Organize content into accessible tabs. Click to swap views instantly without refreshing the page.",
    path: "project/tabs",
  },
  {
    id: 4,
    title: "Modal Popup",
    description: "A focused overlay for alerts or forms. Blocks background interaction to capture user attention.",
    path: "project/modal-popup",
  },

  // --- Phase 2: User Interaction ---
  {
    id: 5,
    title: "Star Rating",
    description: "An interactive rating component. Hover to preview stars and click to set your feedback score.",
    path: "project/star-rating",
  },
  {
    id: 6,
    title: "Light & Dark Mode",
    description: "Switch between day and night themes effortlessly. Uses local storage to remember your preference.",
    path: "project/theme-mode",
  },
  {
    id: 7,
    title: "QR Code Generator",
    description: "Turn any link or text into a scannable QR code instantly. Download and share your codes with ease.",
    path: "project/qr-code-generator",
  },
  {
    id: 8,
    title: "Scroll To Top/Bottom",
    description: "Jump to the start or end of a page instantly. Smooth scrolling behavior for long content.",
    path: "project/scroll-to-top-and-bottom",
  },
  // {
  //   id: 9,
  //   title: "Scroll to Section",
  //   description: "Navigate to a specific part of the page. Uses refs to smoothly glide to the exact content you want.",
  //   path: "project/scroll-to-section",
  // },

  // --- Phase 3: Arrays & Lists ---
  {
    id: 10,
    title: "Image Slider",
    description: "A responsive carousel with smooth transitions. The best way to showcase portfolios or photo galleries.",
    path: "project/image-slider",
  },
  {
    id: 11,
    title: "Load More Data",
    description: "Fetch data in small chunks to boost performance. Includes a button to progressively reveal more content.",
    path: "project/load-more-component",
  },
  {
    id: 12,
    title: "Scroll Indicator",
    description: "A visual progress bar at the top of the page. Lets users know exactly how much content is left to read.",
    path: "project/scroll-indicator",
  },
  {
    id: 13,
    title: "Tic Tac Toe",
    description: "The classic X vs O game. Includes logic for win detection, draws, and resetting the board.",
    path: "project/tic-tac-toe",
  },

  // --- Phase 4: APIs ---
  {
    id: 14,
    title: "GitHub Profile Finder",
    description: "Search for any GitHub user. Fetches their avatar, bio, and repo stats using the public GitHub API.",
    path: "project/github-profile-finder",
  },
  {
    id: 15,
    title: "Search Autocomplete",
    description: "Google-style search. Filters a list of suggestions in real-time as you type, improving search speed.",
    path: "project/search-autocomplete",
  },

  // --- Phase 5: Advanced & Hooks ---
  // {
  //   id: 16,
  //   title: "Feature Flag",
  //   description: "Enable or disable features remotely. Useful for testing new updates without redeploying code.",
  //   path: "project/feature-flag",
  // },
  {
    id: 17,
    title: "useFetch Hook",
    description: "A reusable custom hook for API calls. Handles loading, error, and data states automatically.",
    path: "project/use-fetch-hook",
  },
  {
    id: 18,
    title: "useOnclickOutside",
    description: "Detect clicks outside a specific element. Essential for closing modals and dropdown menus.",
    path: "project/use-onclick-outside-hook",
  },
  {
    id: 19,
    title: "useWindowResize",
    description: "Track the browser window size in real-time. Helps your JS logic adapt to mobile or desktop screens.",
    path: "project/use-window-resize-hook",
  },

  // --- Phase 6: The Challenge ---
  {
    id: 20,
    title: "Tree View / Menu",
    description: "A recursive navigation menu for complex data. Visualize nested folders or categories in a structured list.",
    path: "project/tree-view",
  },
];

export default projects;